// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../types.schema';

export const assignPayloadSchema = z.object({
  annotations: z.array(urlSchema),
  assignees: z.array(urlSchema),
  noteContent: z.string().optional(),
});
